import * as io from "io-ts";

export const Pagination = io.strict({
  index: io.number,
  size: io.number,
  totalElements: io.number,
  totalPages: io.number,
});

export type Pagination = io.TypeOf<typeof Pagination>;

export const PaginationQueryType = io.strict({
  page: io.number,
  pageSize: io.number,
});

export type PaginationQuery = io.TypeOf<typeof PaginationQueryType>;

export const DEFAULT_PAGINATION_VALUE: PaginationQuery = {
  page: 1,
  pageSize: 50,
};
